<template>
    <b-navbar class="navbar docs-navbar is-spaced has-shadow">
        <template slot="brand">
            <b-navbar-item tag="router-link" :to="{ path: '/'}">
                gamesDB
            </b-navbar-item>
        </template>
        <template slot="start">
        </template>
        <template slot="end">
            <b-navbar-item tag="router-link" :to="{ path: '/games'}">
                Games
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/developers'}">
                Developers
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/platforms'}">
                Platforms
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/regions'}">
                Regions
            </b-navbar-item>
            <b-navbar-dropdown label="User">
                <b-navbar-item v-if="!$auth.isAuthenticated" @click="login">Sign in</b-navbar-item>
                <b-navbar-item v-if="$auth.isAuthenticated" :to="{ name: 'profile' }">Profile</b-navbar-item>
                <b-navbar-item v-if="$auth.isAuthenticated" @click="logout">Sign Out</b-navbar-item>
            </b-navbar-dropdown>
        </template>
    </b-navbar>
</template>
<script>
export default {
    data() {
        return {
            game: ''
        }
    },
  methods: {
    getGame() {
    },
    login() {
      this.$auth.loginWithRedirect();
    },
    logout() {
        this.$auth.logout({
            returnTo: "https://gamedb.frlen.net"
        });
    }
  }
}
</script>
